export default "__VITE_ASSET__616bb85c__"